import "../styles/index.css"
import images from "../images/**/*.{jpg,jpeg,png,svg,webp}"

import { registerAnalytics } from "./analytics"
import { registerReveal } from "./reveal"

document.addEventListener("DOMContentLoaded", () => {
  registerAnalytics()
  registerReveal()
})

Object.entries(images)
